module.exports = __webpack_public_path__ + "img/home_banner.8991473c.jpg";